import { useEffect, useState } from 'react';
import { ensureRuntimeEnv } from './runtimeEnv';
export function useRuntimeEnvStatus() {
    const [status, setStatus] = useState(() => typeof window !== 'undefined' && window.serviceManagementEnv ? 'ready' : 'loading');
    useEffect(() => {
        if (status !== 'loading') {
            return;
        }
        let active = true;
        void ensureRuntimeEnv().then(() => {
            if (active)
                setStatus('ready');
        }, () => {
            if (active)
                setStatus('error');
        });
        return () => {
            active = false;
        };
    }, [status]);
    return status;
}
